module.exports = __webpack_public_path__ + "assets/bbfef12e5457d13bf0116add6ca4ec12.mp3";